import { render } from "./ArticleTextEdit.vue?vue&type=template&id=5f4b00ce"
import script from "./ArticleTextEdit.vue?vue&type=script&lang=js"
export * from "./ArticleTextEdit.vue?vue&type=script&lang=js"
script.render = render

export default script